import { api, setTokens } from "./client";

export type User = {
  id: number;
  email: string;
  display_name: string;
  is_staff: boolean;
  storage_used_bytes: number;
  quota_bytes: number;
  created_at: string;
};

export async function login(email: string, password: string): Promise<User> {
  const r = await api.post("/auth/login/", { email, password });
  setTokens(r.data.access, r.data.refresh);
  return r.data.user;
}

export async function me(): Promise<User> {
  const r = await api.get("/auth/me/");
  return r.data;
}

export async function acceptInvitation(
  token: string, password: string, display_name?: string,
): Promise<User> {
  const r = await api.post("/auth/accept-invitation/", { token, password, display_name });
  setTokens(r.data.access, r.data.refresh);
  return r.data.user;
}

export async function checkInvitation(token: string) {
  const r = await api.get(`/invitations/check/${token}/`);
  return r.data as {
    email: string;
    expires_at: string;
    is_valid: boolean;
    already_accepted: boolean;
  };
}

export function logout() {
  setTokens(null, null);
  if (typeof window !== "undefined") location.href = "/login";
}
